import { render, staticRenderFns } from "./Earth.vue?vue&type=template&id=66bb6b12&scoped=true&"
import script from "./Earth.vue?vue&type=script&lang=js&"
export * from "./Earth.vue?vue&type=script&lang=js&"
import style0 from "./Earth.vue?vue&type=style&index=0&id=66bb6b12&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb6b12",
  null
  
)

export default component.exports